import { useContext } from 'react';
import { AuthContext } from '../contexts/JWTContext';
import { AzureEntraContext } from '../contexts/AzureEntraContext';
import { getEnvironmentVariable } from '../utils/env';


// ----------------------------------------------------------------------

const useAuth = () => {
  const authType = getEnvironmentVariable('REACT_APP_AUTH_TYPE');

  const context = useContext(AuthContext);
  const azureEntraContext = useContext(AzureEntraContext);

  switch (authType) {
    case 'ADFS':
      if (!context) throw new Error('Auth context must be use inside AuthProvider');
      return context;
    case 'AzureEntraId':
      if (!azureEntraContext) throw new Error('Auth context must be use inside AuthProvider');
      return azureEntraContext;
    default:
      throw new Error('Auth type is not valid');
  }
};

export default useAuth;